import { For, Show, onMount } from "solid-js";
import { Progress } from "../components/progress";
import { A, Link, useRouteData } from "@solidjs/router";
import { UserSession, AtelierImage } from "../types";
import { fetchGet } from "../library/common";
import toast from "solid-toast";
import { getArtworksCountJson, limits, loadFacultyCms as loadFacultyCms } from "../app";
import { createStore } from "solid-js/store";
import { CMS } from "../components/cms/cms";
import { MultiProgress } from "../components/multi-progress";
import { AtelierImageItem } from "../components/atelier-image-item";
import { MultiProgressPanel } from "../components/multi-progress-panel";
import { SectionHeader } from "../components/section-header";
import { PageLoading } from "../components/page-loading";

type State = {
    isContentReady: boolean;
}

export function InstructorWorks() {
    const [session, setSession] = createStore<UserSession>({ } as UserSession);
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    const [atelierImages, setAtelierImages] = createStore<AtelierImage[]>([]);
    const count = () => atelierImages.length;
    const canApply = true;
    const toastSuccess = (msg: string) => {
        toast.success(msg);
    }
    const toastError = (msg: string) => {
        toast.error(msg);
    }
    const onDeleteClicked = async (id: string) => {
        const params = { id };
        const response = await fetchGet("/AtelierApplication/DeleteAtelierImageJson", params);
        const json = await response.json();
        if (!json.Success) {
            return toastError("Unable to remove the instructor work from your application at this time.");
        }
        const remaining = atelierImages.filter(x => x.Id != id);
        setAtelierImages(remaining);
        await getArtworksCountJson({ forceRefresh: true });
        toastSuccess("The instructor work has been removed from your application.")
    };
    onMount(async() =>{
        const routeData = await useRouteData() as any;
        await loadFacultyCms();
        setSession(routeData.session);
        setAtelierImages(routeData.atelierImages);
        setState({ isContentReady: true });
    })
    
    return (
        <>
            <SectionHeader>
                <h1>
                    Instructor Works
                </h1>
                <p>
                    <a href="/"><CMS text id="nav::home">Home</CMS></a> / <A href="/introduction"><CMS text id="nav::atelier-application">ARC Atelier Application</CMS></A>
                </p>
            </SectionHeader>
            <Show when={state.isContentReady} fallback={<PageLoading />}>
                <div>
                    <Progress step={3}></Progress>
                    <Show when={canApply}>
                        <div class="row ">
                            <div class="col-md-8">
                                <p style="font-size: 1.5em;">
                                    A minimum of {limits.instructorWorks.min} images per fulltime instructor, and a maximum of {limits.instructorWorks.max} images altogther.
                                </p>
                                <h4>
                                    If your school is new and you don't have examples of student work please include 5 examples of each fulltime instructor's work.
                                </h4>
                            </div>
                            <div class="col-md-4">
                                <div class="pull-right">
                                    <MultiProgressPanel
                                        count={count}
                                        min={limits.instructorWorks.min}
                                        max={limits.instructorWorks.max}
                                        entity="instructor work image"
                                    />
                                    <div style="margin-top: 40px;">
                                        <Link class="btn btn-chunky-lg btn-chunky-dark-grey" href={"/faculty"} style={{ "margin-right": "10px"}}>
                                            <CMS id="button::back" text>Back</CMS>
                                        </Link>
                                        <Show when={count() >= limits.instructorWorks.min}>
                                            <A class="btn btn-chunky-lg btn-chunky-goldenrod" href={"/student-works"}><CMS id="button::next" text>Next</CMS></A>
                                        </Show>
                                        <Show when={count() < limits.instructorWorks.min}>
                                            <CMS id="button::next" text>Next</CMS>
                                        </Show>
                                    </div>
                                    <Show when={count() < limits.instructorWorks.max}>
                                        <div style="margin-top: 20px;">
                                            <A class="btn btn-primary" href={"/add-instructor-work"}><span style="margin-right: 10px;" class="fa fa-plus-circle"></span> <CMS id="button::add-instructor-work" text>Add Instructor Work</CMS></A>
                                        </div>
                                    </Show>
                                </div>
                            </div>
                        </div>
                    </Show>
                    <div class="row">
                        <For each={atelierImages}>{(artwork) =>
                            <AtelierImageItem
                                resources={{ canApply }}
                                session={session}
                                deleteClicked={onDeleteClicked}
                                atelierImage={artwork} />
                        }</For>
                        <Show when={count() < limits.instructorWorks.max}>
                            <div class="artwork-container add-artwork-container">
                                <div style="display: table; margin: 0 auto;">
                                    <div style="display: table-row;">
                                        <div style="display: table-cell; height: 300px; vertical-align: middle;">
                                            <A class="btn btn-success" style="font-size: 2em;" href={ "/add-instructor-work" }>
                                                <span style="margin-right: 10px;" class="fa fa-plus-circle"></span><CMS id="button::add-instructor-work" text>Add Instructor Work</CMS>
                                            </A>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Show>
                    </div>
                </div>
            </Show>
        </>
    )
}